export default "__VITE_ASSET__uQYfT0fu__"